var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_vm._m(0),(_vm.linea)?_c('div',{staticClass:"line_booking"}):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-text placeholder-glow"},[_c('div',{staticClass:"placeholder circular_skeleton"}),_c('div',{staticClass:"txt_loader"})])
}]

export { render, staticRenderFns }